import React from 'react'
import { useRouteMatch } from 'react-router-dom'
import { BreadcrumbView } from '../../../context/breadcrumb.context'
import { IconActivityLog } from '../../icon/icon'
import { NoAccess } from '../../../role/components/no-access'
import { useAuditCapabilities } from '../use-audit-capabilities'
import { AuditEntryRoute } from '../entry-route'
import { AuditLogPage } from './audit-log-page'

// /org/audit-log and /admin/audit-log: the Audit log, with an entry's
// permalink (…/entry/:entryID) opening its drawer over the list. The list
// is gated on /capabilities (the organization's on either audit log, the
// super admin's on sysAuditLog); nothing shows while they load. The drawer
// is not gated (AuditEntryRoute: the API decides), so a reader without the
// list who opens a copied link sees just the entry.
export const AuditLogRoute = ({ base, sys = false, home }) => {
  const caps = useAuditCapabilities()
  const onEntry = Boolean(useRouteMatch(`${base}/entry/:entryID`))
  const allowed = Boolean(caps.loaded && (sys ? caps.sysAuditLog : caps.canAudit))

  return (
    <React.Fragment>
      {allowed &&
        <BreadcrumbView Icon={IconActivityLog} text="AUDIT LOG">
          <AuditLogPage sys={sys} caps={caps} />
        </BreadcrumbView>}
      {caps.loaded && !allowed && !onEntry && <NoAccess what="the audit log" />}
      <AuditEntryRoute base={base} sys={sys} home={home} listAllowed={allowed} />
    </React.Fragment>
  )
}
